import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { BaseUrl } from "../config/api";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { removeFromCart } = useCart();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  useEffect(() => {
    const createOrder = async () => {
      try {
        const sessionId = searchParams.get("session_id");
        if (!sessionId) {
          throw new Error("No session ID found");
        }

        // Verify the payment session
        const response = await fetch(`${BaseUrl}/checkout-session/${sessionId}`);
        const session = await response.json();

        if (session.payment_status === "paid") {
          // Get the pending order data from localStorage
          const pendingOrder = JSON.parse(localStorage.getItem("pendingOrder"));
          
          if (pendingOrder) {
            // Create order in backend with isPaid true for online payment
            const orderResponse = await fetch(`${BaseUrl}/orders`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                ...pendingOrder,
                paymentMethod: "online",
                isPaid: true,
                paidAt: new Date(),
                stripeSessionId: sessionId
              }),
            });

            if (!orderResponse.ok) {
              throw new Error("Failed to create order");
            }

            // Clear cart items
            pendingOrder.orderItems.forEach(item => {
              removeFromCart(item.product);
            });

            // Clear stored data
            localStorage.removeItem("pendingOrder");
            localStorage.removeItem("checkoutFormData");
            localStorage.removeItem("selectedItems");

            // Show success popup
            setShowSuccessPopup(true);

            // Redirect after delay
            setTimeout(() => {
              navigate("/");
            }, 3000);
          }
        } else {
          throw new Error("Payment not completed");
        }
      } catch (err) {
        setError("Order creation failed");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    createOrder();
  }, [searchParams, navigate, removeFromCart]);

  if (isLoading) {
    return (
      <div className="payment-loading">
        <h2>Processing your order...</h2>
        <p>Please wait while we confirm your payment and create your order.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-error">
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={() => navigate("/checkout")}>Return to Checkout</button>
      </div>
    );
  }

  return (
    <div className="payment-success">
      {showSuccessPopup && (
        <div className="order-popup-overlay">
          <div className="order-popup">
            <div className="popup-content">
              <div className="box-icon">
                <img
                  src="https://s3-alpha-sig.figma.com/img/b523/1db6/240fd191f3f9ca65c691eddf82b71a51?Expires=1738540800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=NnaeQ49TPjV-qSG2OaHPcW~m4qjfyrNChXE2DQvJ-cJqkNuB7SULVO3g1AJ8xC0R1J3pHz0wWO3RGgbHbKCUzmzm2B9klfe6oabLUVfNwvobZl80ft5U0kEC6erIsjyJMHEIJePGms7LeyRci15Qj-Xdax-CkPOuPSqK8g4rVxZ8xd04iQdftwFfaYDLyZfYB~gNNX9Cu~LAgx0kWPH6U1wH-9xWXLaL8N3xImQRF7wdZRPKbrjxExdMhhL8pxCfCfZE0eVbFDAkjPrlw6heAaqS0A-KTczE1CVUtJswGsx98so2hvwNttP84pvqn6uxtdPg9iFI5xDcX-lhDfw7sA__"
                  alt="success-icon"
                  className="box-icon-img"
                />
              </div>
              <h2>Payment Successful!</h2>
              <p className="order-message">Your order has been placed!</p>
              <p className="reference">Reference# - {searchParams.get("session_id")}</p>
              <p className="relax-message">
                Pull up a chair, sit back and relax
                <br />
                as your order is on its way to you!
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;
